export const drag = {
    state: {
        dragStatus: false,
        dragPackageDayInWeek: null,
        dragSamplePackageDayId: false,
        dragProductId: null
    },
    mutations: {
        SET_DRAG_STATUS(state, status) {
            state.dragStatus = status
        },
        SET_DRAG_PACKAGE_DAY_IN_WEEK(state, packageId) {
            state.dragPackageDayInWeek = packageId
        },
        SET_SAMPLEPACKAGE_DAY_ID(state, dayId) {
            state.dragSamplePackageDayId = dayId
        },
        SET_DRAG_PRODUCT_ID(state, productId) {
            state.dragProductId = productId
        }
    },
    actions: {
        setDragStatus({ commit }, status) {
            commit('SET_DRAG_STATUS', status)
        },
        setDragPackageDayInWeek({ commit }, packageId) {
            commit('SET_DRAG_PACKAGE_DAY_IN_WEEK', packageId)
        },
        setDragSamplePackageDayId({ commit }, dayId) {
            commit('SET_SAMPLEPACKAGE_DAY_ID', dayId)
        },
        setDragProductId({ commit }, productId) {
            commit('SET_DRAG_PRODUCT_ID', productId)
        },
        dragReset({ commit }) {
            commit('SET_DRAG_PACKAGE_DAY_IN_WEEK', null)
            commit('SET_SAMPLEPACKAGE_DAY_ID', false)
            commit('SET_DRAG_STATUS', false)
            commit('SET_DRAG_PRODUCT_ID', null)
        }
    },
    getters: {
        dragPackageDayInWeek: (state) => {
            return state.dragPackageDayInWeek
        },
        dragSamplePackageDayId: (state) => {
            return state.dragSamplePackageDayId
        },
        dragProductId: (state) => {
            return state.dragProductId
        },
        dragStatus: (state) => {
            return state.dragStatus
        }
    }
}
